import styled from 'styled-components';

import { colors } from '../../theme/theme';

export const FitzyTitle = styled.h1`
  font-size: 1.5rem;
  font-weight: bold;
  color: ${colors.primaryDisabled};
  text-decoration: underline ${colors.primary};
  text-decoration-skip-ink: auto;
`;
